import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { MarketViewModule } from '@ddt-web/market-view';

import { CommentaryTextComponent } from './commentary-text/commentary-text.component';
import { FamilyCommentaryComponent } from './family-commentary.component';

@NgModule({
	declarations: [FamilyCommentaryComponent, CommentaryTextComponent],
	imports: [
		CommonModule,
		DataServiceModule,
		DisclosureModule,
		CwpNgFrameworkModule,
		RouterModule.forChild([
			{ path: '', pathMatch: 'full', component: FamilyCommentaryComponent }
		]),
		MarketViewModule
	]
})
export class FamilyCommentaryModule { }
